import { useState, useEffect, useCallback } from 'react';
import weatherService from '../services/weatherService';

export const useWeatherData = () => {
  const [weather, setWeather] = useState(null);
  const [tides, setTides] = useState(null);
  const [waterTemp, setWaterTemp] = useState(null);
  const [waterTempStation, setWaterTempStation] = useState(null);
  const [currentWaterLevel, setCurrentWaterLevel] = useState(null);
  const [moonData, setMoonData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchWeatherData = useCallback(async () => {
    setError(null);
    
    try {
      const data = await weatherService.fetchAllWeatherData();
      
      setWeather(data.weather);
      setTides(data.tides);
      setWaterTemp(data.waterTemp);
      setWaterTempStation(data.waterTempStation);
      setCurrentWaterLevel(data.currentWaterLevel);
      setMoonData(data.moonData);
    } catch (err) {
      setError(err.message);
      // Set empty states to prevent crashes
      setWeather(null);
      setTides([]);
      setWaterTemp(null);
      setWaterTempStation(null);
      setCurrentWaterLevel(null);
      setMoonData(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchWeatherData();
  }, [fetchWeatherData]);

  return {
    weather,
    tides,
    waterTemp,
    waterTempStation,
    currentWaterLevel,
    moonData,
    loading,
    error,
    refetch: fetchWeatherData
  };
};

export default useWeatherData;